<nz-modal
  [(nzVisible)]="isVisibleFuelAndMileageUpdate"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
>
  <ng-template #modalTitle>Current Fuel and Mileage Update</ng-template>

  <ng-template #modalContent>
    <div class="flex flex-col gap-4">
      <p class="font-bold">Current Mileage :</p>
      <nz-input-group nzAddOnAfter="Km">
        <input nz-input type="number" [min]="0" [step]="1" [(ngModel)]="mileage" placeholder="Enter Mileage"/>
      </nz-input-group>
<!--      <nz-input-number-->
<!--        class="w-full"-->
<!--        [(ngModel)]="mileage"-->
<!--        nzPlaceHolder="Enter Mileage"-->
<!--        [nzMin]="0"-->
<!--        [nzStep]="1"-->
<!--        [nzFormatter]="formatterDistance"-->
<!--        [nzParser]="parserDistance"-->
<!--      ></nz-input-number>-->

      <p class="font-bold">Current Fuel Level :</p>
      <nz-input-group nzAddOnAfter="%">
        <input nz-input type="number" [min]="0" [max]="100" [step]="1" [(ngModel)]="fuelLevel" placeholder="Enter Fuel Level"/>
      </nz-input-group>
<!--      <nz-input-number-->
<!--        class="w-full"-->
<!--        [(ngModel)]="fuelLevel"-->
<!--        nzPlaceHolder="Enter Fuel Level"-->
<!--        [nzMin]="0"-->
<!--        [nzMax]="100"-->
<!--        [nzStep]="1"-->
<!--        [nzFormatter]="formatterPercentFuel"-->
<!--        [nzParser]="parserPercentFuel"-->
<!--      ></nz-input-number>-->
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <div class="flex justify-end mb-2">
      <button nz-button nzType="primary"
              [disabled]="(fuelLevel !== 0 || undefined) || (mileage !== 0 || undefined)"
              nz-popconfirm
              nzPopconfirmTitle="Are you sure you want to change the status and without update this information?"
              [nzOkText]="'Yes'" [nzCancelText]="'No'"
              (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
              (nzOnConfirm)="handleOkUpdateFuelAndMileage('without')">Change status without Update data
      </button>
    </div>
    <div class="flex justify-end">
      <button nz-button nzType="default" (click)="handleCancelUpdateFuelAndMileage()">Cancel</button>
      <button nz-button nzType="primary" [disabled]="(fuelLevel === 0 || undefined) || (mileage === 0 || undefined)"
              nz-popconfirm
              nzPopconfirmTitle="Are you sure you want to change the status and save this information?"
              [nzOkText]="'Yes'" [nzCancelText]="'No'"
              (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
              (nzOnConfirm)="handleOkUpdateFuelAndMileage('with')" [nzLoading]="isLoading">Change status and Update data
      </button>
    </div>
  </ng-template>
</nz-modal>
